import { useState, useEffect } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid } from '@mui/material';
import { userService } from 'src/services';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { ActionContext } from 'src/contexts/ActionContext';
import { User } from 'src/models/user/user.model';
import { CURRENT_USER } from 'src/constants';

export default function DialogHeader(props) {
  const {
    hasManagerPermission
  } = useContext(ActionContext);
  const [userInfo, setUserInfo] = useState({
    reference: '',
    firstName: '',
    lastName: ''
  });

  const [reference, setReference] = useState('')
  const params = useParams();
  useEffect(() => {
    if (params.id != undefined) {
      let request = {
        idUser: params.id
      }
      userService.getProfile(request).then(response => {
        if (response.data.success) {
          setUserInfo({
            reference: response.data.data.reference,
            firstName: response.data.data.firstName,
            lastName: response.data.data.lastName
          })
          if (hasManagerPermission) {
            setReference(response.data.data.reference)
          }
        }
      });
    }
  }, []);
  return (
    <>
      <DialogTitle style={{ fontSize: 20, paddingBottom: 0 }}>
        <Grid container direction="row">
          <Grid item xs={7}>{props.title}</Grid>
          <Grid item xs={5} style={{ textAlign: 'right' }}>{reference + " " + userInfo.firstName + " " + userInfo.lastName}</Grid>
        </Grid>
      </DialogTitle>
    </>
  );
}